import type { FaireProductEntity } from "../../entity_types/product";

export const sweet_wink_12: FaireProductEntity = {
  token: "sweet-wink-12",
  type: "product",
  name: "Dainty Rose Pearl Heart Patch Sweatshirt - Kids Clothing",
  brandName: "Sweet Wink",
  imageUrl:
    "https://cdn.faire.com/fastly/21de94a860ed02d2ee6179e9b67e8424a2bf057c064360ec025eeb39dc2f8389.jpeg?bg-color=FFFFFF&dpr=1&fit=crop&format=jpg&height=720&precrop=1079,1079,x0,y0,safe&width=720",
  priceDollars: 22,
  msrpDollars: 44,
  freeShipping: false,
  isBestseller: false,
  description: "",
  categoryTokens: ["cat_kids-all"],
  tags: [],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
